/* eslint-disable camelcase */
import axios from 'axios';
import {
  BOOSTED_PRODUCT_ENDPOINT,
  PREDICTION_PERIOD_STATUS_ENDPOINT,
  PRICE_PROFITABILITY_ENDPOINT,
} from '@dynameat/constants';

export const priceProfitabilityRequest = (prediction_period_guid, price_change_list = []) => axios.post(
  PRICE_PROFITABILITY_ENDPOINT(),
  { prediction_period_guid, price_change_list }
);

export const periodStateRequest = (periodGuid, stateType) => axios.get(PREDICTION_PERIOD_STATUS_ENDPOINT(periodGuid, stateType));
export const boostedProductsRequest = (predictionPeriodGuid) => axios.get(BOOSTED_PRODUCT_ENDPOINT(predictionPeriodGuid));
